import { useState, useEffect } from 'react';
import FormCustomer from 'components/Form/Dwolla/FormCustomer';
import { useLogin } from 'Contexts/AuthProvider/AuthProvider';
import { useEnrollForm } from 'Contexts/EnrollProvider/EnrollProvider';
import { fetchRequestByUser } from 'Helpers/request-by-user';

export default function CompanyForm({
  save,
  setSubmitionOnReview,
  setDataLoaded,
  dataLoaded,
}: any) {
  const [data] = useState(null);
  const [, setValidate] = useState(true);
  // const [validateOwner, setValidateOwner] = useState(true);
  const [, setCustomerId] = useState(null);
  // const [validatebeneficial, setValidateBeneficial] = useState(true);
  // const [isUpload, setIsUpload] = useState(false);
  const [, setBusinessType] = useState('Sole Proprietorship');
  const [isInvitation] = useState(false);
  // const [isOpenModal, setIsOpenModal] = useState(false);
  const [infoDwolla, setInfoDwolla] = useState(null);
  // const [hiddenCreateOwner, setHiddenCreateOwner] = useState(true);
  // const [percentageController, setPercentageController] = useState(0);
  // const [isChecked, setIsChecked] = useState(false);
  // const [validateTwo, setValidateTwo] = useState(true);
  const { user, logout } = useLogin();
  const { setStateDwolla, setStateUsio } = useEnrollForm();

  // const handleClose = () => {
  //   setIsOpenModal(false);
  // };

  useEffect(() => {
    /**
     * Propósito: Precarga el borrador de KYC si el usuario ya tiene solicitud.
     * Sin request (postulación nueva) deja el formulario vacío en vez de
     * reventar al parsear el 400 como JSON.
     */
    const getInfoDwolla = async () => {
      if (!user?.user_id) return;

      const result = await fetchRequestByUser(user);
      setDataLoaded(true);

      if (result.status === 'expired') {
        /**
         * Output:
         * Side effects — Cierra sesión; el token ya no es válido
         */
        logout();
        return;
      }

      if (result.status !== 'ok') {
        /**
         * Output:
         * Side effects — Formulario en blanco para una postulación nueva
         */
        setStateDwolla(0);
        return;
      }

      const request = result.request;

      setStateDwolla(request.status_dwolla_id || 0);
      setStateUsio(request.status_usio_id || 0);

      if (request.status_dwolla_id === 1) {
        setSubmitionOnReview(true);
      }

      if (request.business_type === 'soleProprietorship') {
        setBusinessType('Sole Proprietorship');
      } else if (typeof request.business_type === 'string') {
        /**
         * Output:
         * Side effects — Tipo de negocio del request, o el default del formulario
         */
        setBusinessType(request.business_type);
      }
      /**
       * Output:
       * Side effects — Hidrata el formulario con info_dwolla persistida
       */
      setInfoDwolla((request.info_dwolla as any) || null);
    };
    try {
      getInfoDwolla();
    } catch (error) {
      setDataLoaded(true);
    }
  }, [
    logout,
    setStateDwolla,
    setStateUsio,
    setSubmitionOnReview,
    user?.token,
    user?.user_id,
    setDataLoaded,
  ]);

  // useEffect(() => {
  //   if (isUpload) {
  //     handleClose();
  //   }
  //   if (isUpload == true && validatebeneficial == true) {
  //     setValidateOwner(false);
  //   } else {
  //     setValidateOwner(true);
  //   }
  // }, [isUpload, validatebeneficial]);

  // useEffect(() => {
  //   if (validate === false && isChecked === true) {
  //     setValidateTwo(false);
  //   } else {
  //     setValidateTwo(true);
  //   }
  // }, [validate, isChecked]);

  return (
    <div>
      {dataLoaded && (
        <FormCustomer
          isInvitation={isInvitation}
          data={data as any}
          infoDwolla={infoDwolla as any}
          setValidate={setValidate as any}
          save={save as any}
          setCustomerId={setCustomerId as any}
          _showMessage={() => {}}
          setBusinessType={setBusinessType as any}
          webhook={''}
        />
      )}
    </div>
  );
}
